import * as React from 'react'
// components
import SystemProcessesContainer from 'containers/SystemProcesses'

const SystemProcessesSettingsPage: React.FC = () => <SystemProcessesContainer />

export default SystemProcessesSettingsPage
